// | A closed signature of type-indexed (refined) HTML properties; these can be
// | used to ensure correctness by construction, and then erased into the
// | standard unrefined versions.
import * as $runtime from "../runtime.js";
import * as DOM$dHTML$dIndexed$dAutocompleteType from "../DOM.HTML.Indexed.AutocompleteType/index.js";
import * as DOM$dHTML$dIndexed$dInputAcceptType from "../DOM.HTML.Indexed.InputAcceptType/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Halogen$dHTML$dCore from "../Halogen.HTML.Core/index.js";
import * as Halogen$dQuery$dInput from "../Halogen.Query.Input/index.js";
import * as Halogen$dVDom$dDOM$dProp from "../Halogen.VDom.DOM.Prop/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const IProp = x => x;
const ref = x => Halogen$dVDom$dDOM$dProp.$Prop(
  "Ref",
  x$1 => Data$dMaybe.$Maybe(
    "Just",
    Halogen$dQuery$dInput.$Input(
      "RefUpdate",
      x,
      (() => {
        if (x$1.tag === "Created") { return Data$dMaybe.$Maybe("Just", x$1._1); }
        if (x$1.tag === "Removed") { return Data$dMaybe.Nothing; }
        $runtime.fail();
      })()
    )
  )
);
const prop = dictIsProp => Halogen$dHTML$dCore.prop(dictIsProp);
const readOnly = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("readOnly");
const rel = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("rel");
const required = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("required");
const rowSpan = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("rowSpan");
const rows = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("rows");
const scope = /* #__PURE__ */ (() => {
  const $0 = Halogen$dVDom$dDOM$dProp.Property("scope");
  return x => $0((() => {
    if (x === "ScopeRow") { return "row"; }
    if (x === "ScopeCol") { return "col"; }
    if (x === "ScopeRowGroup") { return "rowgroup"; }
    if (x === "ScopeColGroup") { return "colgroup"; }
    if (x === "ScopeAuto") { return "auto"; }
    $runtime.fail();
  })());
})();
const selected = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("selected");
const selectedIndex = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("selectedIndex");
const spellcheck = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("spellcheck");
const src = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("src");
const srcDoc = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("srcdoc");
const step = /* #__PURE__ */ (() => {
  const $0 = Halogen$dVDom$dDOM$dProp.Property("step");
  return x => $0((() => {
    if (x.tag === "Any") { return "any"; }
    if (x.tag === "Step") { return Data$dShow.showNumberImpl(x._1); }
    $runtime.fail();
  })());
})();
const tabIndex = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("tabIndex");
const target = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("target");
const title = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("title");
const type_ = dictIsProp => {
  const $0 = Halogen$dVDom$dDOM$dProp.Property("type");
  return x => $0(dictIsProp.toPropValue(x));
};
const value = dictIsProp => {
  const $0 = Halogen$dVDom$dDOM$dProp.Property("value");
  return x => $0(dictIsProp.toPropValue(x));
};
const width = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("width");
const preload = /* #__PURE__ */ (() => {
  const $0 = Halogen$dVDom$dDOM$dProp.Property("preload");
  return x => $0((() => {
    if (x === "PreloadNone") { return "none"; }
    if (x === "PreloadAuto") { return "auto"; }
    if (x === "PreloadMetadata") { return "metadata"; }
    $runtime.fail();
  })());
})();
const poster = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("poster");
const placeholder = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("placeholder");
const pattern = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("pattern");
const noValidate = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("noValidate");
const newtypeIProp = {Coercible0: () => {}};
const name = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("name");
const muted = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("muted");
const multiple = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("multiple");
const min = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("min");
const method = /* #__PURE__ */ (() => {
  const $0 = Halogen$dVDom$dDOM$dProp.Property("method");
  return x => $0((() => {
    if (x === "POST") { return "post"; }
    if (x === "GET") { return "get"; }
    if (x === "Dialog") { return "dialog"; }
    $runtime.fail();
  })());
})();
const max = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("max");
const loop = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("loop");
const id = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("id");
const href = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("href");
const height = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("height");
const functorIProp = {
  map: f => m => {
    const $0 = m$1 => {
      if (m$1.tag === "RefUpdate") { return Halogen$dQuery$dInput.$Input("RefUpdate", m$1._1, m$1._2); }
      if (m$1.tag === "Action") { return Halogen$dQuery$dInput.$Input("Action", f(m$1._1)); }
      $runtime.fail();
    };
    if (m.tag === "Handler") {
      return Halogen$dVDom$dDOM$dProp.$Prop(
        "Handler",
        m._1,
        x => {
          const $1 = m._2(x);
          if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", $0($1._1)); }
          return Data$dMaybe.Nothing;
        }
      );
    }
    if (m.tag === "Ref") {
      return Halogen$dVDom$dDOM$dProp.$Prop(
        "Ref",
        x => {
          const $1 = m._1(x);
          if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", $0($1._1)); }
          return Data$dMaybe.Nothing;
        }
      );
    }
    return m;
  }
};
const $$for = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("htmlFor");
const expand = () => Unsafe$dCoerce.unsafeCoerce;
const enctype = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("enctype");
const draggable = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("draggable");
const download = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("download");
const disabled = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("disabled");
const enabled = x => disabled(!x);
const controls = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("controls");
const cols = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("cols");
const colSpan = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("colSpan");
const classes = /* #__PURE__ */ (() => {
  const $0 = Halogen$dVDom$dDOM$dProp.Property("className");
  const $1 = Data$dString$dCommon.joinWith(" ");
  const $2 = Data$dFunctor.arrayMap(Unsafe$dCoerce.unsafeCoerce);
  return x => $0($1($2(x)));
})();
const class_ = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("className");
const checked = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("checked");
const charset = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("charset");
const autoplay = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("autoplay");
const autofocus = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("autofocus");
const autocomplete = /* #__PURE__ */ (() => {
  const $0 = Halogen$dVDom$dDOM$dProp.Property("autocomplete");
  return x => $0(DOM$dHTML$dIndexed$dAutocompleteType.renderAutocompleteType(x));
})();
const attrNS = x => Halogen$dHTML$dCore.attr(Data$dMaybe.$Maybe("Just", x));
const attr = /* #__PURE__ */ Halogen$dHTML$dCore.attr(Data$dMaybe.Nothing);
const list = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Attribute(Data$dMaybe.Nothing)("list");
const style = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Attribute(Data$dMaybe.Nothing)("style");
const alt = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("alt");
const action = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("action");
const accept = /* #__PURE__ */ (() => {
  const $0 = Halogen$dVDom$dDOM$dProp.Property("accept");
  return x => $0(Data$dString$dCommon.joinWith(",")(Data$dFunctor.arrayMap(DOM$dHTML$dIndexed$dInputAcceptType.renderInputAcceptTypeAtom)(x)));
})();
export {
  IProp,
  accept,
  action,
  alt,
  attr,
  attrNS,
  autocomplete,
  autofocus,
  autoplay,
  charset,
  checked,
  class_,
  classes,
  colSpan,
  cols,
  controls,
  disabled,
  download,
  draggable,
  enabled,
  enctype,
  expand,
  $$for as for,
  functorIProp,
  height,
  href,
  id,
  list,
  loop,
  max,
  method,
  min,
  multiple,
  muted,
  name,
  newtypeIProp,
  noValidate,
  pattern,
  placeholder,
  poster,
  preload,
  prop,
  readOnly,
  ref,
  rel,
  required,
  rowSpan,
  rows,
  scope,
  selected,
  selectedIndex,
  spellcheck,
  src,
  srcDoc,
  step,
  style,
  tabIndex,
  target,
  title,
  type_,
  value,
  width
};
